module.exports = __webpack_public_path__ + "static/media/ic_remove.2a7e12d6.svg";